import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import DeletePDFPagesImagesListScreen from "./DeletePDFPagesImagesListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function DeletePDFPagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Delete PDF Pages" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/delete_pdf_pages", title: "Remove PDF Pages" },
    data2: {
      link: "/delete_pdf_pages",
      title: "Remove Selected Pages From PDF",
    },
    data3: { link: "/delete_pdf_pages", title: "Delete PDF Pages Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Delete PDF pages online easily. Remove unwanted pages, edit PDFs, and manage documents quickly with our fast, secure PDF page remover tool."
      ></meta>
      <meta
        name="keywords"
        content="delete PDF pages, remove pages from PDF, PDF page remover, edit PDF online, delete PDF online, PDF editor tool, remove unwanted PDF pages, manage PDF pages, online PDF page editor, PDF document editor, PDF management tool, delete pages in PDF, trim PDF pages, PDF editing tool, PDF page deletion"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <DeletePDFPagesImagesListScreen
          title={title}
        ></DeletePDFPagesImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Delete PDF Pages Offline website provides a fast, secure, and efficient solution to remove unwanted pages from PDF files directly on your device, without requiring an internet connection. Designed for privacy-conscious users, this powerful tool allows you to remove PDF pages, delete selected pages for PDF, and filter documents easily while keeping your files completely offline and secure. Unlike cloud-based tools, all processing happens locally, ensuring sensitive documents never leave your device. The website also supports optional online usage, enabling users to delete PDF pages online or remove PDF pages online for free when internet access is available. Whether you need to clean up large PDFs, remove blank pages, delete confidential sections, or organize documents for sharing, this tool delivers accurate results without affecting the remaining content. With advanced page selection options, users can filter PDF files, preview pages, and delete specific pages in seconds. The platform supports delete PDF pages for free, making it ideal for students, professionals, and businesses looking for a cost-effective PDF solution. Text, images, and formatting are preserved perfectly after page removal, ensuring professional-quality output. Compatible with desktop and mobile devices, this offline PDF page remover helps you manage documents efficiently, save storage space, and prepare PDFs for email, uploads, and official submissions. If you are searching for a secure way to remove PDF pages, delete PDF pages online, remove PDF pages online for free, or delete selected pages for PDF with complete privacy, this website offers a reliable, user-friendly PDF management solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Delete",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Delete PDF Pages"
            why_use={[
              {
                title: "Remove Unwanted PDF Pages Easily",
                description:
                  "Large PDF files often contain extra or blank pages. A delete PDF pages tool helps you quickly remove PDF pages and keep only the relevant content.",
              },
              {
                title: "Delete Selected Pages for PDF Files",
                description:
                  "When only specific pages need to be removed, a delete selected pages for PDF feature allows precise editing without affecting the rest of the document.",
              },
              {
                title: "Reduce PDF File Size",
                description:
                  "Removing unnecessary pages helps shrink document size. Tools that delete PDF pages online create lightweight PDFs for easy sharing and storage.",
              },
              {
                title: "Protect Sensitive Information",
                description:
                  "A remove PDF pages tool helps eliminate confidential or private pages before sharing documents with others.",
              },
              {
                title: "Filter PDF Content Efficiently",
                description:
                  "Advanced tools let you filter PDF pages and remove irrelevant sections, improving document organization and usability.",
              },
              {
                title: "Easy Sharing and Uploading",
                description:
                  "Using a delete PDF pages for free tool helps meet file size limits for email, online forms, and website uploads.",
              },
              {
                title: "Preserve Original Quality and Layout",
                description:
                  "Modern remove PDF pages online for free tools maintain text clarity, images, and formatting after page deletion.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "An offline delete PDF pages tool processes files locally, keeping your documents secure without uploading them online.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students and professionals often delete PDF pages online to customize assignments, reports, contracts, and presentations.",
              },
            ]}
          />{" "}
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default DeletePDFPagesMain;
